var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 1.5C6.1584 1.5 4.66602 2.99239 4.66602 4.83333V6.05001C3.5249 6.28165 2.66602 7.29053 2.66602 8.5V12.1667C2.66602 13.5474 3.7853 14.6667 5.16602 14.6667H10.8327C12.2134 14.6667 13.3327 13.5474 13.3327 12.1667V8.5C13.3327 7.29053 12.4738 6.28165 11.3327 6.05001V4.83333C11.3327 2.99239 9.84028 1.5 7.99935 1.5ZM10.3327 6V4.83333C10.3327 3.54467 9.28802 2.5 7.99935 2.5C6.71068 2.5 5.66602 3.54467 5.66602 4.83333V6H10.3327ZM7.99935 8.83333C8.27548 8.83333 8.49935 9.0572 8.49935 9.33333V11.3333C8.49935 11.6095 8.27548 11.8333 7.99935 11.8333C7.72322 11.8333 7.49935 11.6095 7.49935 11.3333V9.33333C7.49935 9.0572 7.72322 8.83333 7.99935 8.83333Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconFilled);
export default __webpack_public_path__ + "static/media/lock-icon-filled.903d5ad929f5965498a16293d42ea4fa.svg";
export { ForwardRef as ReactComponent };